import { mergeStyles, Stack, Text } from '@fluentui/react';

import ContentBox from '../../ContentBox';
import FormSearch from './FormSearch';

export default () => {
  return (
    <div className={styles}>
      <Stack tokens={stackTokens}>
        <Text variant="xxLarge">Form Arama</Text>
        <ContentBox>
          <FormSearch />
        </ContentBox>
      </Stack>
    </div>
  );
};

const stackTokens = { childrenGap: 10 };
const styles = mergeStyles({
  width: "40%",
  minWidth: "800px",
  transform: "translateX(-50%)",
  marginLeft: "50%",
  marginTop: "8px",
});
